import React from "react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { Mail, Phone, CheckCircle2, ArrowRight } from "lucide-react";

const ViewEmailPhoneModal = ({
  open,
  onClose,
  title = "View Email and Phone Numbers",
  subtitle = "Get verified direct dials, work email addresses, organizational charts, and executive insights.",
}) => {
  const navigate = useNavigate();

  const handleContactUs = () => {
    onClose?.();
    navigate("/contact-us");
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={500}
      className="view-email-phone-modal"
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-text-center tw-pt-4 tw-pb-2 tw-px-2 tw-font-inter">
        {/* Icon Badge */}
        <div className="tw-size-16 tw-rounded-2xl tw-bg-indigo-50 tw-border tw-border-solid tw-border-indigo-100 tw-flex tw-items-center tw-justify-center tw-shadow-sm tw-mb-4">
          <div className="tw-relative">
            <Mail className="tw-size-7 tw-text-[#5D44FF]" />
            <span className="tw-absolute -tw-bottom-1.5 -tw-right-2 tw-size-5 tw-rounded-full tw-bg-white tw-border tw-border-solid tw-border-indigo-100 tw-flex tw-items-center tw-justify-center tw-shadow-xs">
              <Phone className="tw-size-2.5 tw-text-[#5D44FF]" />
            </span>
          </div>
        </div>

        {/* Heading & Subtitle */}
        <h3 className="tw-text-xl tw-font-bold tw-text-slate-850 tw-m-0">
          {title}
        </h3>
        <p className="tw-text-xs tw-text-slate-500 tw-mt-2 tw-mb-0 tw-leading-relaxed tw-max-w-sm">
          {subtitle}
        </p>

        {/* Benefits Card */}
        <div className="tw-w-full tw-bg-slate-50/70 tw-border tw-border-solid tw-border-slate-100 tw-rounded-xl tw-p-3.5 tw-mt-5 tw-text-left">
          <div className="tw-flex tw-flex-col tw-gap-2.5">
            <div className="tw-flex tw-items-center tw-gap-2.5">
              <CheckCircle2 className="tw-size-4 tw-text-emerald-500 tw-shrink-0" />
              <span className="tw-text-xs tw-font-medium tw-text-slate-700">
                100% Verified direct dial and mobile numbers
              </span>
            </div>
            <div className="tw-flex tw-items-center tw-gap-2.5">
              <CheckCircle2 className="tw-size-4 tw-text-emerald-500 tw-shrink-0" />
              <span className="tw-text-xs tw-font-medium tw-text-slate-700">
                Human-validated corporate business emails
              </span>
            </div>
            <div className="tw-flex tw-items-center tw-gap-2.5">
              <CheckCircle2 className="tw-size-4 tw-text-emerald-500 tw-shrink-0" />
              <span className="tw-text-xs tw-font-medium tw-text-slate-700">
                Full organizational charts & decision-maker hierarchy
              </span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="tw-w-full tw-flex tw-flex-col tw-gap-2.5 tw-mt-6">
          <button
            type="button"
            onClick={handleContactUs}
            className="tw-w-full tw-h-11 tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-5 tw-bg-[#5D44FF] hover:tw-bg-indigo-600 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-sm hover:tw-shadow-md tw-transition-all hover:tw-scale-[1.01] tw-border-none tw-outline-none tw-cursor-pointer"
          >
            <span>Contact Us for Access</span>
            <ArrowRight className="tw-size-4" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewEmailPhoneModal;
